// extracted by mini-css-extract-plugin
export var btn = "style-module--btn--bc7da";
export var col = "style-module--col--e67d1";
export var desc = "style-module--desc--86006";
export var gift = "style-module--gift--6435d";
export var mob = "style-module--mob--a569f";
export var nya = "style-module--nya--cb041";
export var screen1 = "style-module--screen1--ee5eb";
export var time = "style-module--time--2e179";
export var type = "style-module--type--2fb78";